import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { postCall } from "../../../Api/axios";
import RenderInput from "../../../utils/RenderInput";
import { deleteAllCookies } from "../../../utils/cookies";
import { toast } from 'react-toastify';
import { useFormik } from "formik";
import * as Yup from "yup";

const passwordFields = [
  {
    id: "password_1",
    title: "Password",
    placeholder: "Password",
    type: "input",
    password: true,
    required: true,
  },
  {
    id: "password_2",
    title: "Confirm Password",
    placeholder: "Confirm Password",
    type: "input",
    password: true,
    required: true,
  },
];

const ResetPassword = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const formik = useFormik({
    initialValues: {
      password_1: '',
      password_2: '',
    },
    validationSchema: Yup.object({
      password_1: Yup.string()
        .required('Password is required')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          `Password must be at least 8 characters, 
          include uppercase, lowercase, number, and special character`
        ),
      password_2: Yup.string()
        .oneOf([Yup.ref('password_1')], "Passwords don't match")
        .required('Confirm Password is required'),
    }),
    onSubmit: async (values) => {
      const url = `/api/v2/dashboard/resetPassword/${user._id}`;
      try {
        await postCall(url, { password: values.password_1, confirmPassword: values.password_2 });
        toast.success("Password set successfully!");
        deleteAllCookies();
        localStorage.clear();
        navigate("/");
      } catch (error) {
        toast.error(error.message);
      }
    },
  });

  useEffect(() => {
    if (user.isSystemGeneratedPassword) {
      navigate("/reset-password");
    } else {
      if (user.role === "ORG_ADMIN") {
        navigate("/orders");
      } else if (user.role === 'SUPER_ADMIN') {
        navigate("/users");
      }
    }
  }, [navigate, user.isSystemGeneratedPassword, user.role]);
  

  const renderSetPasswordFields = () => {
    return passwordFields.map((item) => (
      <RenderInput
        key={item.id}
        item={{
          ...item,
          value: formik.values[item.id],
          onChange: formik.handleChange,
          error: formik.touched[item.id] && Boolean(formik.errors[item.id]),
          helperText: formik.touched[item.id] && formik.errors[item.id],
        }}
      />
    ));
  };

  return (
    <div className="mx-auto !p-5 h-screen min-vh-100 overflow-auto bg-[#f0f0f0]">
      <div className="h-full flex fex-row items-center justify-center">
        <div
          className="flex w-full md:w-2/4 bg-white px-4 py-4 rounded-md shadow-xl h-max scrollbar-hidden"
          style={{ minHeight: "85%", maxHeight: "100%", overflow: "auto" }}
        >
          <div className="m-auto w-10/12 md:w-3/4 h-max">
            <form onSubmit={formik.handleSubmit}>
              <p className="text-2xl font-semibold mb-4 text-center">
                Set Password
              </p>
              <div>
                {renderSetPasswordFields()}
              </div>
              <div className="flex mt-6">
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  color="primary"
                  sx={{ backgroundColor: "#1890ff" }}
                >
                  Continue
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
